import type { Maybe } from '@amazon/vinyl-util'
import type { PlaybackNotice } from '@amzn/bf-playback'
import { toast } from '@/components/toast'
import { toastExplicitBlocked } from '@/explicitLanguageFilter/explicitLanguageFilterService'
import { getStringAsync } from '@/playback/i18n/bundle.generated'

const FAILED_TOAST_BY_MEDIA_TYPE = {
    artist: 'dmusic_playback_failed_artist_toast',
    album: 'dmusic_playback_failed_album_toast',
    playlist: 'dmusic_playback_failed_playlist_toast',
    track: 'dmusic_playback_failed_track_toast',
    station: 'dmusic_playback_failed_station_toast',
    episode: 'dmusic_playback_failed_podcast_toast',
    show: 'dmusic_playback_failed_podcast_toast',
    audiobook: 'dmusic_playback_failed_audiobook_toast',
} as const

/** "Cannot play this <content> at this time", naming the MRN media type; generic when unknown. */
export function toastPlaybackFailed(mediaType: Maybe<string>): void {
    const key =
        mediaType && mediaType in FAILED_TOAST_BY_MEDIA_TYPE
            ? FAILED_TOAST_BY_MEDIA_TYPE[mediaType as keyof typeof FAILED_TOAST_BY_MEDIA_TYPE]
            : 'dmusic_playback_failed_generic_toast'
    toast(getStringAsync(key))
}

export function toastPlaybackNotice(notice: PlaybackNotice): void {
    switch (notice.code) {
        case 'explicitBlocked':
            return toastExplicitBlocked()
        case 'playbackFailed':
            return toastPlaybackFailed(notice.mediaType)
        case 'audiobookUnsupported':
            return toast(getStringAsync('dmusic_playback_failed_audiobook_toast'))
        case 'mediaUnsupported':
            return toast(getStringAsync('dmusic_media_unsupported_toast'))
        case 'queueUpdateFailed':
            return toast(getStringAsync('dmusic_queue_update_failed_toast'))
    }
}
